import Accordion from 'accordion-js';

const accordionEl = document.querySelector('.c-accordion');

if (accordionEl) {
  const secondaryTrigger = accordionEl.querySelectorAll(
    '.c-accordion__trigger--secondary',
  );

  const accordion = new Accordion('.c-accordion', {
    duration: 300,
    showMultiple: true,
    elementClass: 'c-accordion__item',
    triggerClass: 'c-accordion__trigger',
    panelClass: 'c-accordion__panel',
  });

  // Open accordion item conditionally
  const openAccItem = accordionEl.querySelector('[data-acc-open]');

  if (openAccItem) {
    const { accOpen } = openAccItem.dataset;
    accordion.open(Number(accOpen));
  }

  if (secondaryTrigger) {
    Array.from(secondaryTrigger).forEach(trigger => {
      const { target } = trigger.dataset;
      trigger.addEventListener('click', () => {
        accordion.toggle(Number(target));
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/accordion.js